import axios from 'axios';
import MainLayout from "@/components/layout/MainLayout.vue";
import StarRating from "vue-star-rating";
import Pagination from "laravel-vue-pagination";
import VueSlider from "vue-slider-component";
import DatePicker from "vue2-datepicker";
import "vue-slider-component/theme/default.css";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from "vuex";
import LightBox from 'lightbox2';
import 'lightbox2/dist/css/lightbox.css';
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import moment from "moment";

const convertNumberService = new ConvertNumService();

export default {
    name: "classContentGroup",
    components: {
        MainLayout,
        StarRating,
        Pagination,
        DatePicker,
        VueSlider,
        AdvancedLaravelVuePaginate,
        Loading,
        LightBox,
    },

    data() {
        return {
            courses: {
                course_id: "",
                course_title: "",
                course_explanation: "",
                course_details: "",
                certificate: "",
                update_time: "",
                name: "",
                school_name: "",
                teacher_id: "",
                rate: 0,
                experience: "",
                defaultPic: "",
                course_type: ""
            },
            contents: {},
            lastPage: "",
            currentPage: "",
            courseId: this.$route.params.id,
            classId: this.$route.params.id,
            accessEndDate: ''
        }
    },
    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        getContentList(page = 1) {
            axios.get("my/class/" + this.$route.params.id + "/content-gp?page=" + page)
                .then((response) => {
                    this.contents = response.data;
                    this.contents.total = convertNumberService.convertEng2Mm(this.contents.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.contents.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.contents.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.clear();
                });
        },

        getCourseDetail() {
            axios.get("my/course/" + this.$route.params.course_id)
                .then((response) => {
                    this.courses = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 404) {
                        this.$router.push({
                            name: 'notFound'
                        });
                    }
                    if (error.response.status == 403) {
                        this.$router.push({
                            name: 'forbidden'
                        });
                    }
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Detail API Error", error);
                });
        },
    },

    filters: {
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },

    mounted() {
        this.getContentList();
        this.getCourseDetail();
    }
};
